import { Box, Fade, Tooltip, Typography } from '@mui/material'
import CustomChip from '../../../shared/components/CustomChip'
import HighlightIcon from '../../../shared/components/icons/HighlightIcon'
import VisibilityIcon from '../../../shared/components/icons/VisibilityIcon'

interface TableTitleCellProps {
  params: any
  caseFirst: string
  caseSecond: string
  caseThird: string
  caseDefault: string
  onHighlight: (id: number, isHighlight: boolean) => void
}

const TableTitleCell = ({ params, caseFirst, caseSecond, caseThird, caseDefault, onHighlight }: TableTitleCellProps) => {
  const getStatusChip = (status: number) => {
    switch (status) {
      case 0:
        return <CustomChip size="small" color={caseFirst} />
      case 1:
        return <CustomChip size="small" color={caseSecond} />
      case 2:
        return <CustomChip size="small" color={caseThird} />
      default:
        return <CustomChip size="small" color={caseDefault} />
    }
  }

  return (
    <Box display="flex" alignItems="center" gap={1} sx={{ Width: '100%' }}>
      {getStatusChip(params.row.status)}
      <Tooltip placement="bottom-start" TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title={params.row.title}>
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: 340,
            fontWeight: 300,
            '@media (max-width: 600px)': {
              width: 150
            }
          }}
        >
          {params.row.title}
        </Typography>
      </Tooltip>
      <HighlightIcon id={params.row.id} isHighlight={!!params.row.highlight} handleClick={onHighlight} />
      <VisibilityIcon id={params.row.visibility} />
    </Box>
  )
}

export default TableTitleCell
